export default "__VITE_ASSET__0f3634c7__"